import store from '@/store';

const isBypassMode = import.meta.env.VITE_BYPASS_MODE;

export const featureGuard = (featureKey) => (to, from, next) => {
  const isEnabled = store.getters['featureFlagModule/isFeatureEnabled'](featureKey);
  if (isBypassMode || isEnabled) {
    next(); // Feature is enabled, allow access.
  } else {
    next({ name: 'delinquency-dashboard' }); 
  }
};
